import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
    FormControl,
    Select,
    InputLabel,
    Paper,
    Button,
} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';

//components:
import NeuriteGrid from '../../components/neurite_grid';
import DatePicker from '../../components/utils/DatePicker';

//actions:
import { navigate, openDialog } from '../../actions';

//helpers:
import { getData, getTextFile, postData } from '../../dataLib';
import * as config from '../../constants/configuration';

const styles = theme => ({
    containerView: {
        width: '83vw',
        height: '83vh',
        marginTop: 135,
    },
    paperCentroDia: {
        paddingTop: 0,
        paddingBottom: theme.spacing(1) / 2,
        paddingLeft: theme.spacing(1) / 2,
        paddingRight: theme.spacing(1) / 2,
        margin: theme.spacing(1),
    },
    form: {
        maxWidth: 595,
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 20,
    },
    formControl: {
        minWidth: 120,
        maxWidth: 310,
        margin: 0,
        padding: 0,
    },
    spinnerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '20px !important',
        height: '20px !important',
    },
    textField: {
        width: 145,
        margin: 0,
        padding: 0,
    },
    acceptContainer: {
        width: '19%',
        display: 'flex',
    },
    button: {
        borderRadius: 0,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        color: 'white',
        textTransform: 'capitalize',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: 'white',
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class ExportarContabilidad extends Component {
    constructor(props) {
        super(props);
        this.state = {
            centro: this.props.centroDiaSelected.centro.id
                ? this.props.centroDiaSelected.centro.id
                : 1,
            iniDate: null,
            endDate: null,
            centroDiaCierre: 1,
            lastExportDate: null,
            pdfLoading: false,
            loaded: false,
            asientos: [],
        };
    }

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(''); //go to home page
            return;
        }

        this.getLastExportDate(this.state.centro);
    }

    handleCentroChange = event => {
        const value = parseInt(event.target.value);

        var centroSelected = this.props.centros.find(c => c.id === value);
        if (centroSelected !== undefined) {
            this.getLastExportDate(centroSelected.id);
            this.setState({
                ...this.state,
                centro: centroSelected.id,
                centroDiaCierre: centroSelected.iDiaCierre,
                loaded: false,
            });
        }
    };

    centroSelectList = () => {
        // return this.props.centros.filter(c => c.isGroup === false && c.activo === 1).map(centro => {
        //     return (
        //         <option key={centro.id} value={centro.id}>{centro.centro}</option>
        //     );
        // });

        //return this.props.centros.filter(c => c.isGroup === false && c.activo === 1).map(centro => {
        return this.props.centros
            .filter(c => c.activo === 1)
            .map(centro => {
                return (
                    <option key={centro.id} value={centro.id}>
                        {centro.centro}
                    </option>
                );
            });
    };

    handleIniDateValueChange = event => {
        //var dt = new Date(event);
        //if (dt.getDay() !== this.state.centroDiaCierre + 1) return;

        this.setState({
            ...this.state,
            iniDate: event,
            loaded: false,
        });
    };

    handleEndDateValueChange = event => {
        //var dt = new Date(event);
        //if (dt.getDay() !== this.state.centroDiaCierre) return;

        this.setState({
            ...this.state,
            endDate: event,
            loaded: false,
        });
    };

    getLastExportDate = centro => {
        getData(
            'Contabilidad/UltimaExportacion?centro_id=' + centro,
            response => {
                const dt = new Date(response.data.slice(0, 10));
                const iniDate = new Date(
                    Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate() + 1),
                );
                const endDate = new Date(
                    Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate() + 7),
                );

                this.setState({
                    ...this.state,
                    lastExportDate: dt.toISOString().slice(0, 10),
                    iniDate: iniDate.toISOString().slice(0, 10),
                    endDate: endDate.toISOString().slice(0, 10),
                });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching last export date',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    getContabilidad = () => {
        //let failed = false;

        const dtIni = new Date(this.state.iniDate);
        const dtEnd = new Date(this.state.endDate);
        const dtExp = new Date(this.lastExportDate);

        if (dtIni < dtExp) {
            this.props.openDialog(
                'SimpleMessage',
                {
                    message:
                        'La fecha inicial tiene que ser posterior a la última fecha de exportación',
                },
                uuidv4(),
                false,
                'sm',
            );
            this.setState({ ...this.state, pdfLoading: false });
        } else if (dtIni.getDay() !== this.state.centroDiaCierre + 1) {
            this.props.openDialog(
                'SimpleMessage',
                {
                    message:
                        'La fecha inicial tiene que ser un día de inicio semanal',
                },
                uuidv4(),
                false,
                'sm',
            );
            this.setState({ ...this.state, pdfLoading: false });
        } else if (dtEnd.getDay() !== this.state.centroDiaCierre) {
            this.props.openDialog(
                'SimpleMessage',
                {
                    message:
                        'La fecha final tiene que ser un día de cierre semanal',
                },
                uuidv4(),
                false,
                'sm',
            );
            this.setState({ ...this.state, pdfLoading: false });
        } else {
            getData(
                'Contabilidad?centro_id=' +
                this.state.centro +
                '&date_ini=' +
                this.state.iniDate +
                '&date_end=' +
                this.state.endDate,
                response => {
                    this.setState({
                        ...this.state,
                        pdfLoading: false,
                        loaded: true,
                        asientos: response.data,
                    });
                },
                async error => {
                    //failed = true;
                    const message = await new Response(
                        error.response.data,
                    ).text();
                    this.props.openDialog(
                        'SimpleMessage',
                        {
                            message: 'ERROR: ' + message,
                        },
                        uuidv4(),
                        false,
                        'sm',
                    );
                },
                this.props.user,
                false,
            );
        }
    };

    downloadContabilidad = () => {
        let failed = false;

        // const dtIni = new Date(this.state.iniDate);
        // const dtEnd = new Date(this.state.endDate);
        // const dtExp = new Date(this.lastExportDate);

        // if (dtIni < dtExp) {
        //     this.props.openDialog('SimpleMessage', {
        //         message: 'La fecha inicial tiene que ser posterior a la última fecha de exportación'
        //     }, uuidv4(), false, 'sm');
        //     this.setState({ ...this.state, pdfLoading: false });
        // }
        // else if (dtIni.getDay() !== this.state.centroDiaCierre + 1) {
        //     this.props.openDialog('SimpleMessage', {
        //         message: 'La fecha inicial tiene que ser un día de inicio semanal'
        //     }, uuidv4(), false, 'sm');
        //     this.setState({ ...this.state, pdfLoading: false });
        // }
        // else if (dtEnd.getDay() !== this.state.centroDiaCierre) {
        //     this.props.openDialog('SimpleMessage', {
        //         message: 'La fecha final tiene que ser un día de cierre semanal'
        //     }, uuidv4(), false, 'sm');
        //     this.setState({ ...this.state, pdfLoading: false });
        // }
        // else {

        getTextFile(
            'Contabilidad?centro_id=' +
            this.state.centro +
            '&date_ini=' +
            this.state.iniDate +
            '&date_end=' +
            this.state.endDate +
            '&text=true',
            undefined,
            async error => {
                failed = true;
                const message = await new Response(error.response.data).text();
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR: ' + message,
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            () => {
                this.setState({ ...this.state, pdfLoading: false });
                if (!failed) {
                    this.props.openDialog(
                        'ConfirmationDialog',
                        {
                            message:
                                'Archivo descargado correctamente. Desea bloquear la exportación hasta esta fecha?',
                            acceptHandler: () => {
                                this.bloquearContabilidad(
                                    this.state.centro,
                                    this.state.endDate,
                                );
                            },
                        },
                        uuidv4(),
                        false,
                        'sm',
                    );
                }
            },
            'contabilidad_' +
            this.state.centro +
            '_' +
            this.state.iniDate +
            '_' +
            this.state.endDate +
            '.txt',
            this.props.user,
        );
        // }
    };

    bloquearContabilidad = (centro, date) => {
        postData(
            'contabilidad/bloquearContabilidad?centro_id=' +
            centro +
            '&date=' +
            date,
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'Actualizada fecha de última exportación',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
                //this.setState({...this.state, lastExportDate: date });
                const dt = new Date(date.slice(0, 10));
                const iniDate = new Date(
                    Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate() + 1),
                );
                const endDate = new Date(
                    Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate() + 7),
                );
                this.setState({
                    ...this.state,
                    lastExportDate: date,
                    iniDate: iniDate.toISOString().slice(0, 10),
                    endDate: endDate.toISOString().slice(0, 10),
                });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR cerrando contabilidad',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            {},
            this.props.user,
        );
    };

    render() {
        const { classes } = this.props;

        //const centros = this.props.centros.filter(c => c.isGroup === false && c.activo === 1);
        const centros = this.props.centros.filter(c => c.activo === 1);

        return (
            <div className={classes.containerView}>
                <Paper className={classes.paperCentroDia} elevation={0}>
                    <form className={classes.form}>
                        <FormControl className={classes.formControl}>
                            <InputLabel>Centro</InputLabel>

                            <Select
                                native
                                value={this.state.centro}
                                onChange={event =>
                                    this.handleCentroChange(event)
                                }
                            >
                                {centros.find(
                                    c => c.id === this.state.centro,
                                ) === undefined ? (
                                        <option key={'centro_0'} value={0}>
                                            {'Seleccione un centro'}
                                        </option>
                                    ) : (
                                        ''
                                    )}
                                {this.centroSelectList()}
                            </Select>
                        </FormControl>

                        {this.props.isLoading ? (
                            <div className={classes.spinnerContainer}>
                                <CircularProgress
                                    className={classes.spinner}
                                    color="primary"
                                />
                            </div>
                        ) : (
                                ''
                            )}
                        {centros.find(c => c.id === this.state.centro) !==
                            undefined ? (
                                <Tooltip
                                    title="Fecha en la que se realizó la última exportación"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 500 }}
                                    placement="right"
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <FormControl>
                                        <DatePicker
                                            label="Última exportación"
                                            value={this.state.lastExportDate}
                                            className={classes.textField}
                                            disabled
                                        />
                                    </FormControl>
                                </Tooltip>
                            ) : null}
                    </form>

                    {centros.find(c => c.id === this.state.centro) !==
                        undefined ? (
                            <form className={classes.form}>
                                <Tooltip
                                    title="Fecha inicio intervalo de exportación"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 500 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <FormControl>
                                        <DatePicker
                                            label="Fecha inicial"
                                            value={this.state.iniDate}
                                            className={classes.textField}
                                            onChange={event => {
                                                if (event && !isNaN(event)) {
                                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                                    this.handleIniDateValueChange(d.toISOString().slice(0, 10))
                                                }
                                            }}
                                        />
                                    </FormControl>
                                </Tooltip>

                                <Tooltip
                                    title="Fecha fin intervalo de exportación"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 500 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <FormControl>
                                        <DatePicker
                                            label="Fecha final"
                                            value={this.state.endDate}
                                            className={classes.textField}
                                            onChange={event => {
                                                if (event && !isNaN(event)) {
                                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                                    this.handleEndDateValueChange(d.toISOString().slice(0, 10))
                                                }
                                            }}
                                        />
                                    </FormControl>
                                </Tooltip>


                                <div className={classes.acceptContainer}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={
                                            this.props.isLoading ? true : false
                                        }
                                        className={classes.button}
                                        onClick={() => {
                                            this.setState({
                                                ...this.state,
                                                pdfLoading: true,
                                            });
                                            this.getContabilidad();
                                        }}
                                    >
                                        Obtener contabilidad
                                </Button>
                                </div>
                            </form>
                        ) : (
                            ''
                        )}
                </Paper>
                {this.state.pdfLoading ? (
                    <LinearProgress
                        className={classes.linearSpinner}
                        variant="indeterminate"
                    />
                ) : (
                        ''
                    )}
                {this.state.loaded ? (
                    <div>
                        <NeuriteGrid
                            id="a_e_c"
                            columns={[
                                {
                                    key: 'fechaAsiento',
                                    name: 'Fecha',
                                    editable: false,
                                    dragable: false,
                                    type: 'date',
                                    width: 85,
                                },
                                {
                                    key: 'numeroAsiento',
                                    name: 'Asiento',
                                    editable: false,
                                    dragable: false,
                                    width: 80,
                                },
                                {
                                    key: 'comentario',
                                    name: 'Cometario',
                                    editable: false,
                                    dragable: false,
                                    width: 150,
                                },
                                {
                                    key: 'descripcion',
                                    name: 'Descripción',
                                    editable: false,
                                    dragable: false,
                                    width: 250,
                                },
                                {
                                    key: 'cuenta',
                                    name: 'Cuenta',
                                    editable: false,
                                    dragable: false,
                                    width: 150,
                                },
                                {
                                    key: 'debe',
                                    name: 'Debe',
                                    editable: false,
                                    dragable: false,
                                    type: 'float',
                                    width: 100,
                                },
                                {
                                    key: 'haber',
                                    name: 'Haber',
                                    editable: false,
                                    dragable: false,
                                    type: 'float',
                                    width: 100,
                                },
                            ]}
                            rows={this.state.asientos}
                            buttonEdit={false}
                            buttonDelete={false}
                            buttonNew={false}
                            height={400}
                        />
                        <div className={classes.acceptContainer}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={this.props.isLoading ? true : false}
                                className={classes.button}
                                onClick={() => {
                                    this.setState({
                                        ...this.state,
                                        pdfLoading: true,
                                    });
                                    this.downloadContabilidad();
                                }}
                            >
                                Descargar archivo
                            </Button>
                        </div>
                    </div>
                ) : (
                        ''
                    )}
            </div>
        );
    }
}

// getTextFile(url, thenHandler, errorHandler, filename, user)
ExportarContabilidad.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centros: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centros: state.centros.centros,
        isLoading: state.centros.isLoading,
        centroDiaSelected: state.centroDiaSelected,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators(
        {
            navigate,
            openDialog,
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispathToProps,
)(withStyles(styles, { withTheme: true })(ExportarContabilidad));
